import { Mesh } from "three";
import {
  RigidBodyAutoCollider,
  RigidBodyTypeString,
} from "@react-three/rapier";

export enum CollisionShape {
  Sphere = "Sphere",
  Box = "Box",
  Trimesh = "Trimesh",
}

export enum CollisionType {
  Static = "Static",
  Dynamic = "Dynamic",
  KinematicPosition = "KinematicPosition",
  KinematicVelocity = "KinematicVelocity",
}

export const CollisionShapeMap: Record<CollisionShape, RigidBodyAutoCollider> =
  {
    [CollisionShape.Sphere]: "ball",
    [CollisionShape.Box]: "cuboid",
    [CollisionShape.Trimesh]: "trimesh",
  };

export const CollisionTypeMap: Record<CollisionType, RigidBodyTypeString> = {
  [CollisionType.Static]: "fixed",
  [CollisionType.Dynamic]: "dynamic",
  [CollisionType.KinematicPosition]: "kinematicPosition",
  [CollisionType.KinematicVelocity]: "kinematicVelocity",
};

export type CollisionObjectProps = {
  meshNode: Mesh;
  isPlayer?: boolean;
  mass?: number;
  collisionShape: CollisionShape;
  collisionType?: CollisionType;
  collisionAttach?: boolean;
  collisionMatchRotation?: boolean;
  parentToCollision?: boolean;
  friction?: number;
  sensor?: boolean;
  restitution?: number;
  onPlayerCollide?: () => void;
};

export const PhysicalContexts = [
  "Box",
  "Ball",
  "Wall",
  "ComplexWall",
  "Structure",
  "Platform",
  "Player",
];

export const OmitPhysicalContextsForControl = ["Player"];
